import {
  ListConversationsQueryRootKey,
  ListMessagesQueryRootKey,
} from '../gen/service/creativefabrica/studioagent/v1'

export const aidaChatKeys = {
  conversations: [ListConversationsQueryRootKey] as const,
  conversation: (conversationId: string) => ['aida-chat', 'conversation', conversationId] as const,
  messages: (conversationId: string) =>
    [ListMessagesQueryRootKey, JSON.stringify({ conversationId })] as const,
}
